import React, { useState, useEffect } from "react";
import AuthUser from '../Auth/AuthUser';
import { DialogContent, Grid, Select, FormControl, MenuItem, InputLabel, Box, TextField, Dialog, InputAdornment, DialogActions, OutlinedInput, Backdrop, DialogTitle, Tab, useMediaQuery } from '@mui/material';
import { Typography, Card, CardContent, CardOverflow, Button } from '@mui/joy';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import * as Yup from 'yup';
import { Formik, FieldArray } from 'formik';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SnapshotOperationalHours from '../../Components/SnapshotOperationalHours';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import swal from "sweetalert";
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';
import { fetchData, postData, postFormData } from '../../redux/apiSlice';
import Freez from '../../Components/Loader/Loader';
import { styled } from '@mui/material/styles';
import SnapshotOperationalHours from "./SnapshotOperationalHours";
import iIcon from '../../assets/images/i_icon.png';
import InfoIcon from '@mui/icons-material/Info';
import Visibility from '@mui/icons-material/Visibility';
import { TabContext, TabPanel, TabList } from '@mui/lab';
import { snapshot, updateCrsSignupEnabled } from '../../redux/authSlice';
import CompanyDetails from './CompanyDetails';
import UploadSnapshotLogo from './UploadSnapshotLogo';
import SnapshotSocialMediaLink from './SnapshotSocialMediaLink';
import SnapshotPopupSetUp from './SnapshotPopupSetUp';
import config from '../../AppConfig';
import { exampleHTML } from '../../../src/views/Web/CreditSnapshot/CreditTermsAndCondition';
import jsPDF from 'jspdf';

let blankValueIndexes1 = [];
let blankValueIndexes2 = [];
let operationalhoursvalues = [];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 350,
        },
    },
};

const CustomInputAdornment = styled(InputAdornment)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    '& .MuiIconButton-root': {
        padding: '3px', // Apply reduced padding to all IconButtons
    },
}));
const CreditSnapShotSetup = ({receivedphone , defaultPhoneNumber, receivedemails, defaultEmail, receivedpid, receivedaid, business, creditinfo, pids, aidlist1, firstAid, receivedshift, fetchCreditInfo, defaultOutOfOfficeMsg, firstlogoUrl, firstlogoText, firstlogoType, companyId, link, customColorArray, snapshotStr,terms}) => {
    const { http, user } = AuthUser();
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const [value, setValue] = React.useState('1');
    const [freez, setFreez] = React.useState(false);
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDownloadPDF = async (data) => {
        // console.log(data);
        const firstName = data ? data.reference_affiliates.first_name ? data.reference_affiliates.first_name : "" : "";
        const lastName = data ? data.reference_affiliates.last_name ? data.reference_affiliates.last_name : "" : "";
        const fullName = firstName + " " + lastName;
        const companyName = data ? data.company.company_name ? data.company.company_name : "" : "";
        const title = data ? data.company.title ? data.company.title : "" : "";
        const updateDate = data ? data.updated_at ? data.updated_at : "" : "";
        const sign = data ? data.sign_image : "";
        const executiveSign = data ? data.executive : "";
        const dateFormat = new Date(updateDate);
        const options = { timeZone: 'America/Los_Angeles', month: '2-digit', day: '2-digit', year: 'numeric' };
        const formatter = new Intl.DateTimeFormat('en-US', options);
        const [
            { value: month }, ,
            { value: day }, ,
            { value: year }
        ] = formatter.formatToParts(dateFormat);
    
        const formattedDate = `${month}/${day}/${year}`;
        const advertiser = {
            adverstise: companyName,
            signature: fullName,
            printName: fullName,
            title: title,
            date: formattedDate
        };
    
        const sample = ` <div style="font-size:16px;padding: 5px 0px;width:750px;text-align:justify;"> 
            <p>
            <span style="font-size: 18px; text-align: center;"><b>Standard Terms and Conditions for Lead Generation Service: Lead Generation (Last revised Jan 12 2025)</b></span>
            </p>
            <br><br>
                ${exampleHTML(advertiser)}
                <br>
                <div class="forMD-12" style="display: flex; flex-wrap: wrap; margin-top: 2px;">
                <div class="forMD-6" style="flex: 1; min-width: 65%;">
                    <p style="margin: 0; padding: 2px;"><strong>Advertiser: ${companyName}</strong></p>
                    <p style="margin: 0; padding: 2px; display: flex; align-items: center;">
                        <strong>Signature:</strong>
                        ${sign ?
                `<img src="${sign}" alt="Signature" style="width: 40%; height: auto;" />`
                :
                `<span style="margin-left: 10px;">${fullName}</span>`
            }
                    </p>
                    <p style="margin: 0; padding: 2px;"><strong>Print Name: ${fullName}</strong></p>
                    <p style="margin: 0; padding: 2px;"><strong>Title: ${title}</strong></p>
                    <p style="margin: 0; padding: 2px;"><strong>Date: ${formattedDate}</strong></p>
                </div>
                <div class="forMD-6" style="flex: 1; min-width: 35%;">
                    <p style="margin: 0; padding: 2px;"><strong>Vendor: MyFreeScoreNow Inc.</strong></p>
                    <p style="margin: 0; padding: 2px; display: flex; align-items: center;">
                        <strong>Signature:</strong>
                        <img src="${executiveSign}" alt="Executive Signature" style="width: 45%; height: auto; margin-left: 10px;" />
                    </p>
                    <p style="margin: 0; padding: 2px;"><strong>Print Name: Bruce J. Cornelius</strong></p>
                    <p style="margin: 0; padding: 2px;"><strong>Title: President</strong></p>
                    <p style="margin: 0; padding: 2px;"><strong>Date: ${formattedDate}</strong></p>
                </div>
              </div>
              
            </div>`
        var pdf = new jsPDF("p", "px", "a4");
        const paddingTop = 20;
        const paddingBottom = 30;
        pdf.html(sample, {
            margin: [0, 10, 30, 10],
            callback: function (pdf) {
                const totalPages = pdf.internal.getNumberOfPages();
                const totalPadding = paddingTop + paddingBottom;
                for (let i = 0; i < totalPages; i++) {
                    pdf.setPage(i + 1);
    
                    pdf.text(
                        `Page ${i + 1} of ${totalPages}`,
                        pdf.internal.pageSize.width / 2,
                        pdf.internal.pageSize.height - 10,
                        { align: 'center', fontSize: '12px' }
                    );
                    pdf.internal.pageSize.height += totalPadding; // Adjust the page height
                }
                pdf.save('Agreement_Copy.pdf');
            },
            x: 30,
            y: 30,
            autoPaging: 'text',
            html2canvas: { scale: 0.50 },
            width: pdf.internal.pageSize.getWidth() - 20,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleOpen2 = () => {
        setOpen2(true);
    };

    return (
        <>
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
            <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} >
                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between" }} >
                <Grid item lg={7} md={7} sm={12} xs={12} sx={{ textAlign: "left", marginTop: isMobile ? 2 : 0 }}>
                    <Grid container item lg={12} md={12} sm={12} xs={12} >
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "left" }}>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: "left" }}>
                                <Card sx={{ width: "98%",boxShadow:"none", minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "150px", padding: 0 }}>
                                    <a onClick={handleOpen2} href="#" style={{ textDecoration: "none" }}><Typography sx={{ textAlign: "center",color:"black"  }} level="body1" >Consumer Experience</Typography></a>
                                    <div onClick={handleOpen2} style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
                                        <iframe
                                            width="100%"
                                            height={isMobile ? "80px" : "100px"}
                                            src="https://www.youtube.com/embed/G5Y429vuUcI?si=AKS1ypfC4WluYr7r"
                                            title="Video Player"
                                            // frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </Card>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: "right" }}>
                                <Card sx={{ width: "98%",boxShadow:"none", minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "150px", padding: 0 }}>
                                    <a onClick={handleOpen} href="#" style={{ textDecoration: "none" }}><Typography sx={{ textAlign: "center",color:"black" }} level="body1" >How To Set Up Credit Snapshot</Typography></a>
                                    <div onClick={handleOpen} style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
                                        <iframe
                                            width="100%"
                                            height={isMobile ? "80px" : "100px"}
                                            src="https://www.youtube.com/embed/wuMiZJgJsfE?si=z5THKTUlj3zYoUoM"
                                            title="Video Player"
                                            // frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item lg={5} md={5} sm={12} xs={12} sx={{ textAlign: "right" }}>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Grid item lg={12} md={12} sm={6} xs={6} sx={{ marginTop: isMobile ? 0 : 2 }}>
                            {/* {user.roles_id === 3 ? (
                                <Button
                                    color="primary"
                                    sx={{ fontWeight: "bold" }}
                                    onClick={() => handleDownloadPDF(terms)}
                                >
                                    DOWNLOAD AGREEMENT COPY
                                </Button>
                            ) : null} */}
                             <img src={require('../../assets/images/credit_snapshot_logo.png')} alt="Credit Snapshot" style={{ height: "65px" }} />
                        </Grid>
                    </Grid>
                </Grid>
                </Grid>
                 <Grid item lg={12} md={12} sm={12} xs={12} mt={2}> 
                    <Typography level="h4"  sx={{  color:"black",fontWeight : "600" }}> Get Started In Just A Few Easy Steps</Typography>
                </Grid>
                <TabContext value={value} sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', width: "100%" }}>
                        <Grid container item lg={12} md={12} sm={12} xs={12} >
                            <TabList onChange={handleChange} aria-label="secondary tabs example" className="tab-list"
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                sx={{
                                    
                                    '& .MuiTab-root': {
                                      fontWeight: 'normal', // default font weight
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                   
                                    },
                                    '& .MuiTab-root.Mui-selected': {
                                      color: 'success.main',
                                      fontWeight: 'bold', // make only selected tab bold
                                    },
                                    '& .MuiTabs-indicator': {
                                      backgroundColor: 'success.main',
                                    },
                                  }}

                            >
                                <Tab label="1. Setup Credit Snapshot" value="1" />
                                <Tab label="2. Edit Or Upload Logo" value="2" disabled={receivedpid ? false : true}/>
                                <Tab label="3. Get Your Link" value="3" disabled={receivedpid ? false : true}/>
                                <Tab label="4. Promote Your Link" value="4" disabled={receivedpid ? false : true}/>
                            </TabList>
                        </Grid>
                    </Box>
                    <TabPanel value="1" sx={{ width: "100%",padding:"2px !important" }}><CompanyDetails receivedphone={receivedphone} defaultPhoneNumber={defaultPhoneNumber} receivedemails={receivedemails} defaultEmail={defaultEmail} receivedpid={receivedpid} receivedaid={receivedaid} business={business} creditinfo={creditinfo} pids={pids} aidlist1={aidlist1} firstAid={firstAid} fetchCreditInfo={fetchCreditInfo} defaultOutOfOfficeMsg={defaultOutOfOfficeMsg} terms={terms}/></TabPanel>
                    <TabPanel value="2" sx={{width:"100%",padding:"2px !important" }} ><UploadSnapshotLogo creditinfo={creditinfo} firstlogoUrlValue={firstlogoUrl} firstlogoTextValue={firstlogoText} firstlogoTypeValue={firstlogoType} companyId={companyId} fetchCreditInfo={fetchCreditInfo} source="company"/></TabPanel>
                    <TabPanel value="3" sx={{width:"100%",padding:"2px !important" }}><SnapshotSocialMediaLink creditinfo={creditinfo} firstlogoUrlValue={firstlogoUrl} companyId={companyId} receivedpid={receivedpid} link={link}/></TabPanel>
                    <TabPanel value="4" sx={{width:"100%",padding:"2px !important" }}><SnapshotPopupSetUp firstlogoUrl={firstlogoUrl} receivedpid={receivedpid} creditinfo={creditinfo} companyId={companyId} link={link} fetchCreditInfo={fetchCreditInfo} customColorArray={customColorArray} snapshotStr={snapshotStr}/></TabPanel>
                </TabContext>
                {/* MUI Dialog */}
            </Grid>

        </>
    );
}

export default CreditSnapShotSetup;